export function decodeFBString(str) {
  const arr = [];
  if (str && str.length) {
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i);
      arr.push(charCode);
    }
    const uintArray = new Uint8Array(arr);
    const decoder = new TextDecoder("utf-8");
    const decodedStr = decoder.decode(uintArray);
    return decodedStr;
  }
}

export function disableRightClick(event) {
  event.preventDefault();
}

export function compressedImage(url) {
  //only for cloudinary images
  const uploadIndex = url.indexOf("/image/upload/");

  if (uploadIndex === -1) {
    return url; // Return the original URL if "/image/upload/" is not found
  }

  const modifiedUrl =
    url.slice(0, uploadIndex + 14) +
    "w_1000/q_auto/f_auto/" +
    url.slice(uploadIndex + 14);
  return modifiedUrl;
}

// EMOJIS TO JSON READABLE CODE
export function encodeSpecialCharsToDoubleEscapedUTF8(input) {
  const encoder = new TextEncoder();
  let result = "";

  for (const char of input) {
    if (/[\x00-\x7F]/.test(char)) {
      // ASCII character, keep it as-is
      result += char;
    } else {
      // Non-ASCII: encode to UTF-8 bytes and escape each byte
      const bytes = encoder.encode(char);
      for (const byte of bytes) {
        result += "\\u00" + byte.toString(16).padStart(2, "0");
      }
    }
  }

  return result;
}

// Example
const input = "⚠️ Caution: Handle With Care ⚠️";
const output = encodeSpecialCharsToDoubleEscapedUTF8(input);
// console.log(output);
